import React, {useEffect, useRef, useState, useCallback} from 'react';
import {BrowserRouter, Routes, Route, useNavigate} from 'react-router-dom';
import Loader from './components/Loader.jsx';
import ErrorBlock from './components/ErrorBlock.jsx';
import {apiGetUserByTelegram} from './api/backend.js';
import Welcome from './pages/Welcome.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Access from './pages/Access.jsx';
import {getTelegramInfo} from './utils/telegram.js';
import BottomNav from './components/BottomNav.jsx';
import Instructions from './pages/Instructions.jsx';
import './App.css'
import {daysLeft} from './utils/format.js';

function AppInner() {
  const [{id: telegramId, username}] = useState(getTelegramInfo());
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const left = user?.expireAt ? Number(daysLeft(user.expireAt)) : NaN;
  const expired = !user || !(left > 0);
  const expiredStatus = user ? user.status === 'EXPIRED' : false;

  const loadUser = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const u = await apiGetUserByTelegram(telegramId);
      setUser(u);
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setLoading(false);
    }
  }, [telegramId]);



  useEffect(() => {
    loadUser();
  }, [loadUser]);


  const handlePaid = useCallback(async () => {
    const started = Date.now();
    let u = null;
    while (!u && Date.now() - started < 20000) {
      await new Promise(r => setTimeout(r, 1500));
      u = await apiGetUserByTelegram(telegramId);
    }
    if (!u) throw new Error('Оплата прошла, но аккаунт ещё активируется. Обнови кабинет через пару секунд.');
    setUser(u);
    navigate('/');
  }, [telegramId, navigate]);

  return (
    <div className={'parent'}>
      {loading && <Loader />}
      {error && <ErrorBlock error={error} />}

      {!loading && !error && (
        <Routes>
          {!expired ? (
            <>
              <Route path="/" element={<Dashboard user={user}/>}/>
              <Route path="/access" element={<Access user={user}/>}/>
              <Route path="/instructions" element={<Instructions user={user}/>}/>
            </>
          ) : null}
          <Route path="/*" element={<Welcome onPaid={handlePaid} expired={expiredStatus}/>}/>
        </Routes>
      )}

      {!loading && !error && user && !expired ? <BottomNav /> : null}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppInner/>
    </BrowserRouter>
  );
}
